 document.addEventListener("DOMContentLoaded", function(event) {
if (window.innerWidth < 1025) {
  var swiper = new Swiper(".block_tab-collection-2 .block_mobproduct_full", {
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    freeMode: {
      enabled: true,
      momentumBounce: false,
    },
    grid: {
      rows: 3,
    },
    scrollbar: {
      el: ".block_tab-collection-2 .swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-2 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-2 .block_slider-left-arrow",
    },
  });

  var swiper = new Swiper(".block_tab-collection-2 .block_mobtab-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    observer: true,
    observeParents: true,
    freeMode: {
      enabled: true,
      momentumBounce: false,
    },
    scrollbar: {
      el: ".block_tab-collection-2 .swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-2 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-2 .block_slider-left-arrow",
    },
    breakpoints: {
      280: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      340: {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
      400: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      749: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });

  var swiper = new Swiper(".block_tab-collection-2 .block_mobtab-slider-full", {
    slidesPerView: 4.136,
    spaceBetween: 20,
    observer: true,
    observeParents: true,
    freeMode: {
      enabled: true,
      momentumBounce: false,
    },
    scrollbar: {
      el: ".block_tab-collection-2 .swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-2 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-2 .block_slider-left-arrow",
    },
    breakpoints: {
      280: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      340: {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
      400: {
        slidesPerView: 1.4,
        spaceBetween: 10,
      },
      580: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
    },
  });
} else {
  var swiper = new Swiper(".block_tab-collection-2 .block_product_full", {
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    grid: {
      rows: 3,
    },
    scrollbar: {
      el: ".block_tab-collection-2 .swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-2 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-2 .block_slider-left-arrow",
    },
  });

  var swiper = new Swiper(".block_tab-collection-2 .block_tab-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    observer: true,
    observeParents: true,
    scrollbar: {
      el: ".block_tab-collection-2 .swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-2 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-2 .block_slider-left-arrow",
    },
    breakpoints: {
      1025: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1280: {
        slidesPerView: 3,
      },
    },
  });

  var swiper = new Swiper(".block_tab-collection-2 .block_tab-slider-full", {
    slidesPerView: 4.136,
    observer: true,
    observeParents: true,
    spaceBetween: 20,
    scrollbar: {
      el: ".block_tab-collection-2 .swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-2 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-2 .block_slider-left-arrow",
    },
    breakpoints: {
      1025: {
        slidesPerView: 2.8,
        spaceBetween: 10,
      },
      1366: {
        slidesPerView: 3.5,
      },
    },
  });
}
 })